import React from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'

import { PagesBanner } from '../'
import './CMSDefault.sass'


const CMSDefault = ({ title, bgClassName, contentData }) => {
  return (
    <div className="page__wrapper">
      <Helmet>
        <title>{contentData.title} | Gulf TREE</title>
      </Helmet>
      <PagesBanner bgClassName={bgClassName} title={contentData.title} />
      <section className="page__content cms__content markdown-bullet-list" dangerouslySetInnerHTML={{__html: contentData.content}} />
    </div>
  )
}

CMSDefault.propTypes = {
  bgClassName: PropTypes.string,
  contentData: PropTypes.shape({
    content: PropTypes.string.isRequired,
    title: PropTypes.title
  }).isRequired
}

export default CMSDefault
